import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import hero_bg from "../assets/hero_bg.jpg"
import Marquee from 'react-fast-marquee';
const services = [
  "App Development",
  "AI Solutions",
  "Cloud Services",
  "UI/UX Design",
  "Automation",
  "E-commerce",
  "Business Strategy",
  "Data Analytics",
];
const ServiceHero = ({ herotitle, heroSubtitle }) => {
  return (
<section className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900 text-white">

      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-32 h-32 bg-blue-500 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute top-40 right-32 w-24 h-24 bg-purple-500 rounded-full opacity-20 blur-2xl"></div>
        <div className="absolute bottom-32 left-1/3 w-40 h-40 bg-cyan-500 rounded-full opacity-15 blur-3xl"></div>
        <div className="absolute top-1/2 right-1/4 w-20 h-20 bg-pink-500 rounded-full opacity-10 blur-2xl"></div>
      </div>
<div className="relative max-w-7xl mx-auto px-6 py-20  overflow-hidden lg:py-40 pb-56">

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
              {herotitle?.start}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
                {herotitle?.highlight}
              </span>
            </h1>

            <p className="text-xl text-slate-300 leading-relaxed">
             {heroSubtitle}
            </p>

            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-3 rounded-lg font-semibold flex items-center space-x-2 transition-colors">
              <span>Let's Talk</span>
              <FaArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* Right Illustration - Digital Security Theme */}
          <div className="relative flex justify-center">
            <div className="relative">
              {/* Digital Padlock */}
              <div className="relative w-48 h-48">
                {/* Padlock Body */}
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-24 bg-gradient-to-br from-purple-500 to-blue-600 rounded-lg opacity-90">
                  {/* Binary code pattern overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-transparent to-purple-700 rounded-lg"></div>
                  <div className="absolute inset-2 border border-cyan-400 rounded opacity-50"></div>
                </div>

                {/* Padlock Shackle */}
                <div className="absolute top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 border-8 border-purple-400 rounded-full border-b-transparent"></div>

                {/* Digital particles */}
                <div className="absolute top-0 left-0 w-2 h-2 bg-cyan-400 rounded-full opacity-70 animate-pulse"></div>
                <div className="absolute top-4 right-2 w-1 h-1 bg-blue-400 rounded-full opacity-60 animate-pulse delay-100"></div>
                <div className="absolute bottom-8 left-2 w-1.5 h-1.5 bg-purple-400 rounded-full opacity-80 animate-pulse delay-200"></div>
                <div className="absolute bottom-2 right-4 w-1 h-1 bg-pink-400 rounded-full opacity-50 animate-pulse delay-300"></div>
              </div>

              {/* Circular rings */}
              <div className="absolute inset-0 -m-16">
                <div className="w-80 h-80 border-2 border-cyan-400 rounded-full opacity-30 animate-pulse"></div>
              </div>
              <div className="absolute inset-0 -m-24">
                <div className="w-96 h-96 border border-blue-400 rounded-full opacity-20 animate-pulse delay-500"></div>
              </div>

              {/* Data streams */}
              <div className="absolute top-1/4 -left-8 w-16 h-0.5 bg-gradient-to-r from-transparent via-cyan-400 to-transparent opacity-60 animate-pulse"></div>
              <div className="absolute bottom-1/4 -right-8 w-20 h-0.5 bg-gradient-to-r from-transparent via-purple-400 to-transparent opacity-50 animate-pulse delay-700"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Client Logos Card - Integrated into Hero */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 z-30 w-full px-6">

        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-2xl shadow-lg py-8 px-2">
            <div className="text-center mb-8">
              <p className="text-slate-800 text-lg font-medium">Your One-Stop Partner for Tech, Design & Strategy</p>
            </div>

            {/* Marquee Container */}
                 <Marquee speed={50} gradient={false} className="overflow-hidden">
        {services.map((service, index) => (
          <span
            key={index}
            className="font-bold text-xl mx-8 whitespace-nowrap text-sky-600"
          >
            {service}
          </span>
        ))}
      </Marquee>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
